import { SERVICES } from '../config/church'
import type { Screen } from '../core/types'
import { homeBar, pageHeader } from './chrome'

export function createWorshipScreen(): Screen {
  return {
    mount(root, ctx) {
      root.classList.add('screen--page')
      root.appendChild(pageHeader('예배 안내', '주일 예배와 주중 집회'))

      const body = document.createElement('div')
      body.className = 'page__body'

      for (const group of SERVICES) {
        const section = document.createElement('section')
        section.className = 'schedule'

        const heading = document.createElement('h2')
        heading.className = 'schedule__heading'
        heading.textContent = group.heading
        section.appendChild(heading)

        for (const entry of group.entries) {
          const row = document.createElement('div')
          row.className = 'schedule__row'

          const label = document.createElement('div')
          label.className = 'schedule__label'
          const name = document.createElement('span')
          name.className = 'schedule__name'
          name.textContent = entry.name
          label.appendChild(name)
          if (entry.note) {
            const note = document.createElement('span')
            note.className = 'schedule__note'
            note.textContent = entry.note
            label.appendChild(note)
          }

          const time = document.createElement('span')
          time.className = 'schedule__time'
          time.textContent = entry.time

          row.append(label, time)
          section.appendChild(row)
        }
        body.appendChild(section)
      }

      root.appendChild(body)
      root.appendChild(homeBar(ctx.go))
    },
  }
}
